<template>
  <div class="accordion-card-title">
    <div class="status-dot" :class="status"></div>
    <div class="img-container">
      <img :src="require(`@/assets/icons/${imgName}`)" :alt="subtitle" />
    </div>
    <div class="title-text"> 
        <p>{{ title }}</p>      
        <p class="assessment-description"> {{ subtitle }} </p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { defineProps } from 'vue';
defineProps(['imgName', 'title', 'subtitle', 'status'])
</script>
<style lang="scss">
.accordion-card-title{
        display: flex;
        align-items: center;
        position: relative;
        cursor: pointer;
        img {
            flex-shrink: 0;
            margin-right: 1rem;
            flex-shrink: 0;
            margin-right: 1rem;
            padding: 1.5rem;
            border-right: 1px solid #ddd;
            background-color: $grey-light;
        }
        .title-text{
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            font-weight: 500;
            line-height: 1.3;
            flex-wrap: wrap;
            padding: 0.5rem;
            flex-shrink: 2;
            .assessment-description {
                font-size: 0.8rem;
                font-weight: 300;
                color: $grey;
            }
        }
    }
</style>
